import * as React from 'react'
import { ReactElement } from 'react'
import { Button, makeStyles, shorthands, tokens } from '@fluentui/react-components'
import { CheckmarkRegular, DismissRegular } from '@fluentui/react-icons'
import { useFormikContext } from 'formik'
import DeleteDialog from '../../components/Dialog/DeleteDialog'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import useAxios from '../../hooks/useAxios'
import { NavigationState } from './Navigation'

type Props = {
    selected?: NavigationState
    setSelected: (state: NavigationState) => void
    submitDisabled?: boolean
    deleteUrl?: () => string
    reset: () => void
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        ...shorthands.gap(tokens.spacingHorizontalL, tokens.spacingVerticalS),
        flexDirection: 'row',
        flexWrap: 'wrap',
        '> *': {
            display: 'flex',
            ...shorthands.gap(tokens.spacingVerticalS),
        },
    },
    primary: {
        order: 1,
    },
    secondary: {
        order: 2,
    },
})

export default function NavigationFormButtons(props: Props): ReactElement {
    const axios = useAxios()
    const { submitForm } = useFormikContext()
    const styles = useStyles()
    const themeClassName = useThemeClassName_unstable()

    return (
        <div className={styles.container}>
            <div className={styles.primary}>
                <Button
                    appearance="primary"
                    icon={<CheckmarkRegular />}
                    onClick={submitForm}
                    disabled={props.submitDisabled ?? false}
                >
                    Opslaan
                </Button>
                <Button icon={<DismissRegular />} onClick={() => props.setSelected(undefined)}>
                    Annuleren
                </Button>
            </div>
            {!props.selected.isNew && props.deleteUrl && (
                <div className={styles.secondary}>
                    <DeleteDialog
                        className={themeClassName}
                        onDelete={setOpen => {
                            axios.delete(props.deleteUrl()).finally(() => {
                                props.setSelected(undefined)
                                props.reset()
                                setOpen(false)
                            })
                        }}
                    />
                </div>
            )}
        </div>
    )
}
